import { ODateResponse, SubscriptionEntity, SubscriptionsFilterTypes } from "common/interfaces/subscriptions";
import i18n from "i18next";
import { BaseApiService } from "./BaseApiService";

class SubscriptionRepository extends BaseApiService {
  constructor() {
    super("match");
  }
  fetchSaleEnabledAbonements = () =>
    this.get<ODateResponse<SubscriptionEntity>>(
      "odata/Event?$orderby=EventId%20desc&$filter=(Type eq 'Subscription' or Type eq 'Packet') and IsHidden eq false"
    );
  fetchByFilter = async (filters: SubscriptionsFilterTypes) => {
    const locale = i18n.language === "ru" ? "Ru" : "En";

    const { value: subscriptions, ["@odata.count"]: count } = await this.get(
      `odata/Event?$count=true&$skip=${filters.pagination * filters.pageSize - filters.pageSize}&$top=${
        filters.pageSize
      }&$orderby=${filters.sorting}&$filter=(Type eq 'Subscription' or Type eq 'Packet')${
        filters.FullName ? ` and contains(tolower(FullName/${locale}), '${filters.FullName.trim().toLowerCase()}')` : ""
      }`
    );

    return { subscriptions, count };
  };

  fetchById = async (id: SubscriptionEntity["Id"]) => {
    const { value } = await this.get(`odata/Event?$filter=Id eq ${id}`);

    return value[0];
  };

  updateSubscription = async (subscription: SubscriptionEntity) =>
    await this.post("Event/Update", JSON.stringify(subscription));

  hiddenEvent = async (eventId: string) => {
    await this.get(`Event/HideEvent/${eventId}`);
  };

  publishEvent = async (eventId: string) => {
    await this.get(`Event/PublishEvent/${eventId}`);
  };
}

export const subscriptionRepository = new SubscriptionRepository();
